class NumberObject extends Number {
  /**
   * Check if the number is within a range
   *
   * @param {number} min
   * @param {number} max
   * @returns {boolean}
   */
  inRange(min, max) {
    const value = this.valueOf();
    return value >= min && value <= max;
  }

  /**
   * Check if the number is equal to a value
   *
   * @param {number} value
   * @returns {boolean}
   */
  equals(value) {
    // This is not necessary strictly because JavaScript will coerce the
    // instance using valueOf() when checking equality with ==, but the
    // TypeScript checker complains about that.
    return this.valueOf() === value;
  }
}

export { NumberObject };
